import { TASK_BOARD_ICONS } from 'Data/constants.js'

export function boardName(value, isNew) {
  return isNew === 'new' ? 'New Board' : value
}

export function boardIcon(value, isNew) {
  return isNew === 'new' ? TASK_BOARD_ICONS[0].id : value
}
